// extracted by mini-css-extract-plugin
module.exports = {"main":"Main_main__msHnp","main__content":"Main_main__content__yuajZ","main__footer":"Main_main__footer__M8dea","main__lazy-footer":"Main_main__lazy-footer__M5k92"};